import { render, staticRenderFns } from "./TraceyAiEmptyHero.vue?vue&type=template&id=1a05a797&scoped=true"
import script from "./TraceyAiEmptyHero.vue?vue&type=script&lang=js"
export * from "./TraceyAiEmptyHero.vue?vue&type=script&lang=js"
import style0 from "./TraceyAiEmptyHero.vue?vue&type=style&index=0&id=1a05a797&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a05a797",
  null
  
)

export default component.exports